import {
  HAZARD_MARKERS,
  Scheme,
  UiListTileBackgroundColor,
  UiListTileLeadingColor,
  WarningSubType,
  WarningSubTypes,
} from '@/features/hazards';

type WarningsToSchemeMap = Record<WarningSubType, Scheme>;

export const warningsToSchemeMap: WarningsToSchemeMap = {
  // Air Quality
  [WarningSubTypes.AirQualityEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-air-quality--emergency-warning'],
  },
  [WarningSubTypes.AirQualityWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-air-quality--watch-and-act'],
  },
  [WarningSubTypes.AirQualityAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-air-quality--advice'],
  },

  // Blizzard
  [WarningSubTypes.BlizzardEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-blizzard--emergency-warning'],
  },
  [WarningSubTypes.BlizzardWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-blizzard--watch-and-act'],
  },
  [WarningSubTypes.BlizzardAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-blizzard--advice'],
  },

  // Extreme Cold
  [WarningSubTypes.ExtremeColdEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-extreme-cold--emergency-warning'],
  },
  [WarningSubTypes.ExtremeColdWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-extreme-cold--watch-and-act'],
  },
  [WarningSubTypes.ExtremeColdAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-extreme-cold--advice'],
  },

  // Flash Flood
  [WarningSubTypes.FlashFloodEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-flash-flood--emergency-warning'],
  },
  [WarningSubTypes.FlashFloodWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-flash-flood--watch-and-act'],
  },
  [WarningSubTypes.FlashFloodAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-flash-flood--advice'],
  },

  // Freezing Rain
  [WarningSubTypes.FreezingRainEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-freezing-rain--emergency-warning'],
  },
  [WarningSubTypes.FreezingRainWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-freezing-rain--watch-and-act'],
  },
  [WarningSubTypes.FreezingRainAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-freezing-rain--advice'],
  },

  // Ice Jam
  [WarningSubTypes.IceJamEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-ice-jam--emergency-warning'],
  },
  [WarningSubTypes.IceJamWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-ice-jam--watch-and-act'],
  },
  [WarningSubTypes.IceJamAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-ice-jam--advice'],
  },

  // Lake Flooding
  [WarningSubTypes.LakeFloodingEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-lake-flooding--emergency-warning'],
  },
  [WarningSubTypes.LakeFloodingWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-lake-flooding--watch-and-act'],
  },
  [WarningSubTypes.LakeFloodingAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-lake-flooding--advice'],
  },

  // Power Outage (EMO graduated levels)
  [WarningSubTypes.PowerOutageEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-power-outage--emergency-warning'],
  },
  [WarningSubTypes.PowerOutageWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-power-outage--watch-and-act'],
  },

  // River Flooding
  [WarningSubTypes.RiverFloodingEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-river-flooding--emergency-warning'],
  },
  [WarningSubTypes.RiverFloodingWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-river-flooding--watch-and-act'],
  },
  [WarningSubTypes.RiverFloodingAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-river-flooding--advice'],
  },

  // Seasonal Overland Flooding
  [WarningSubTypes.SeasonalOverlandFloodingEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-seasonal-overland-flooding--emergency-warning'],
  },
  [WarningSubTypes.SeasonalOverlandFloodingWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-seasonal-overland-flooding--watch-and-act'],
  },
  [WarningSubTypes.SeasonalOverlandFloodingAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-seasonal-overland-flooding--advice'],
  },

  // Severe Winter Weather
  [WarningSubTypes.SevereWinterWeatherEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-severe-winter-weather--emergency-warning'],
  },
  [WarningSubTypes.SevereWinterWeatherWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-severe-winter-weather--watch-and-act'],
  },
  [WarningSubTypes.SevereWinterWeatherAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-severe-winter-weather--advice'],
  },

  // Tornado
  [WarningSubTypes.TornadoEmergencyWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-tornado--emergency-warning'],
  },
  [WarningSubTypes.TornadoWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-tornado--watch-and-act'],
  },
  [WarningSubTypes.TornadoAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-tornado--advice'],
  },

  // Generic (Other) graduated levels
  [WarningSubTypes.OtherEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-other-warning--emergency-warning'],
  },
  [WarningSubTypes.OtherWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-other-warning--watch-and-act'],
  },

  [WarningSubTypes.BushfireAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-bushfire--advice'],
  },
  [WarningSubTypes.BushfireWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-bushfire--watch-and-act'],
  },
  [WarningSubTypes.BushfireEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-bushfire--emergency-warning'],
  },

  // Coastal Hazards
  [WarningSubTypes.CoastalHazardAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-coastal-hazard--advice'],
  },
  [WarningSubTypes.CoastalHazardWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-coastal-hazard--watch-and-act'],
  },
  [WarningSubTypes.CoastalHazardEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-coastal-hazard--emergency-warning'],
  },

  // Cyclone
  [WarningSubTypes.CycloneAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-cyclone--advice'],
  },
  [WarningSubTypes.CycloneWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-cyclone--watch-and-act'],
  },
  [WarningSubTypes.CycloneEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-cyclone--emergency-warning'],
  },

  // Damaging Winds
  [WarningSubTypes.DamagingWindsAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-damaging-winds--advice'],
  },
  [WarningSubTypes.DamagingWindsWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-damaging-winds--watch-and-act'],
  },
  [WarningSubTypes.DamagingWindsEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-damaging-winds--emergency-warning'],
  },

  // Earthquake
  [WarningSubTypes.EarthquakeAlertWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Blue,
    icon: HAZARD_MARKERS['ew-earthquake-alert'],
  },
  [WarningSubTypes.EarthquakeFinalAlertWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Gray,
    icon: HAZARD_MARKERS['ew-earthquake-final-alert'],
  },

  // Flood
  [WarningSubTypes.FloodAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-flood--advice'],
  },
  [WarningSubTypes.FloodWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-flood--watch-and-act'],
  },
  [WarningSubTypes.FloodEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-flood--emergency-warning'],
  },

  // Hazardous Materials
  [WarningSubTypes.HazmatControlledContainedWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Gray,
    icon: HAZARD_MARKERS['ew-hazmat-controlled-contained'],
  },
  [WarningSubTypes.HazmatGeneralWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-hazmat-general-warning'],
  },

  // Heatwave
  [WarningSubTypes.HeatwaveAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-heatwave--advice'],
  },
  [WarningSubTypes.HeatwaveWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-heatwave--watch-and-act'],
  },
  [WarningSubTypes.HeatwaveEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-heatwave--emergency-warning'],
  },

  // Smoke
  [WarningSubTypes.SmokeAlertWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-smoke-alert'],
  },

  // Storm
  [WarningSubTypes.StormAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-storm--advice'],
  },
  [WarningSubTypes.StormWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-storm--watch-and-act'],
  },
  [WarningSubTypes.StormEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-storm--emergency-warning'],
  },

  // Storm Surge
  [WarningSubTypes.StormSurgeAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-storm-surge--advice'],
  },
  [WarningSubTypes.StormSurgeWatchAndActWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Orange,
    icon: HAZARD_MARKERS['ew-storm-surge--watch-and-act'],
  },
  [WarningSubTypes.StormSurgeEmergencyWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-storm-surge--emergency-warning'],
  },

  // Structure Fire
  [WarningSubTypes.StructureFireAdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-structure-fire-warning'],
  },
  [WarningSubTypes.StructureFireAllClearWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Gray,
    icon: HAZARD_MARKERS['ew-structure-fire-contained-controlled'],
  },

  // Tsunami
  [WarningSubTypes.TsunamiAllClearWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Gray,
    icon: HAZARD_MARKERS['ew-tsunami-all-clear'],
  },
  [WarningSubTypes.TsunamiLandWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-tsunami-land-warning'],
  },
  [WarningSubTypes.TsunamiMarineWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Red,
    icon: HAZARD_MARKERS['ew-tsunami-marine-warning'],
  },
  [WarningSubTypes.TsunamiWatchWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-tsunami-watch'],
  },

  // Total Fire Ban
  [WarningSubTypes.TotalFireBanWarningEntity]: {
    icon: HAZARD_MARKERS['ew-total-fire-ban'],
    leadingColor: UiListTileLeadingColor.Red,
    backgroundColor: UiListTileBackgroundColor.Pink,
  },
  [WarningSubTypes.NoTotalFireBanWarningEntity]: {
    icon: HAZARD_MARKERS['ew-no-total-fire-ban'],
  },

  // Other
  [WarningSubTypes.OtherWarningWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-other-warning'],
  },

  // Miscellaneous
  [WarningSubTypes.WarningLocationSpecificWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-warning-location-specific'],
  },
  [WarningSubTypes.PowerOutageWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Yellow,
    icon: HAZARD_MARKERS['ew-power-outage'],
  },
  [WarningSubTypes.WarningStateWideWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-state-wide-warning'],
  },
  [WarningSubTypes.CommunityInformationWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-community-information'],
  },
  [WarningSubTypes.AdviceWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-advice'],
  },
  [WarningSubTypes.AlertWarningEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-alert'],
  },
};
